import i from"graphql-tag";import{CircleSessionFragmentDoc as n,CircleFacilitatorFragmentDoc as r}from"./fragments.generated.es.js";import*as s from"@apollo/react-hooks";const o={},c=i`
    query fetchSession($sessionId: ID!) {
  circleSession(id: $sessionId) {
    id
    ...CircleSession
  }
}
    ${n}
${r}`;function y(e){const t={...o,...e};return s.useQuery(c,t)}function f(e){const t={...o,...e};return s.useLazyQuery(c,t)}const a=i`
    query fetchSessionsByDateTime($startDateTime: DateTime!, $endDateTime: DateTime!, $after: String, $before: String, $first: Int, $last: Int) {
  circleSessionsByDateTime(
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    __typename
    ... on CircleSessionConnection {
      totalCount
      edges {
        cursor
        node {
          id
          ...CircleSession
        }
      }
    }
  }
}
    ${n}
${r}`;function D(e){const t={...o,...e};return s.useQuery(a,t)}function $(e){const t={...o,...e};return s.useLazyQuery(a,t)}export{c as FetchSessionDocument,a as FetchSessionsByDateTimeDocument,f as useFetchSessionLazyQuery,y as useFetchSessionQuery,$ as useFetchSessionsByDateTimeLazyQuery,D as useFetchSessionsByDateTimeQuery};
//# sourceMappingURL=sessions.generated.es.js.map
